document.addEventListener('DOMContentLoaded', () => {

  // ── Cached globals ───────────────────────────────────
  const canHover = window.matchMedia('(hover: hover)').matches;


// ── Gemstone Drawers ─────────────────────────────────
  function initGemstoneDrawers() {
    document.querySelectorAll('x-drawer[id^="gemstone-drawer"]').forEach(drawer => {

      if (drawer._gemstoneInitialised) return;
      drawer._gemstoneInitialised = true;

      const drawerId = drawer.id;

      const cards                = Array.from(drawer.querySelectorAll('.gemstone-card'));
      const addBtn               = drawer.querySelector('[slot="footer"] .button');
      const selectedLabel        = drawer.querySelector('.gemstone-drawer__selected-label');
      const listView             = drawer.querySelector('.gemstone-list-view');
      const detailViews          = Array.from(drawer.querySelectorAll('.gemstone-detail-view'));
      const viewBtns             = Array.from(drawer.querySelectorAll('.gemstone-card__view-btn'));
      const backBtns             = Array.from(drawer.querySelectorAll('.gemstone-back-btn'));
      const selectFromDetailBtns = Array.from(drawer.querySelectorAll('.gemstone-detail__select-btn'));
      const triggerBtn           = document.querySelector(`[aria-controls="${drawerId}"]`);

      // NEW: Filled (solid) black by default so the customer knows to click it
      // before choosing a gemstone. Prestige's .button--outline class makes it
      // transparent — removing it falls back to the theme's solid button style.
      if (triggerBtn) triggerBtn.classList.remove('button--outline');

      if (!addBtn) return;

      let selectedVariantId   = null;
      let cartedVariantId     = null;
      let gemstoneAddedToCart = false;
      let selectedGemstoneName = null;

      // The trigger button names the chosen stone once one is in the cart.
      // Falls back to the Liquid-supplied generic label when the name can't
      // be resolved - e.g. the stone sold out, so its card is no longer
      // rendered (product-info.liquid guards on variants.first.available).
      function selectedLabelText() {
        return selectedGemstoneName
          ? 'Change: ' + selectedGemstoneName
          : (drawer.dataset.labelSelected || 'Change Your Gemstone');
      }

      if (listView) listView.style.display = 'block';

      async function checkCartForGemstone() {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          const productId = drawer.dataset.productId || '';

          const gemstoneItem = cart.items.find(item =>
            item.properties &&
            item.properties['_gemstone'] === 'true' &&
            (item.properties['_for_product'] === productId ||
             item.properties['_for_product'] === '' ||
             !item.properties['_for_product'])
          );

          if (gemstoneItem) {
            cartedVariantId = String(gemstoneItem.variant_id);
            gemstoneAddedToCart = true;

            // Prefer the drawer's own card so this path and the add-to-cart
            // path produce an identical string; fall back to the cart title.
            const cartedCard = Array.from(cards).find(
              c => String(c.dataset.variantId) === cartedVariantId
            );
            selectedGemstoneName = cartedCard
              ? cartedCard.dataset.gemstoneName
              : (gemstoneItem.product_title || null);

            if (triggerBtn) {
              triggerBtn.textContent = selectedLabelText();
              triggerBtn.classList.add('button--outline'); // NEW: transparent once a gemstone is already in cart
            }
          }
        } catch (err) {
          console.error('Failed to check cart for gemstone:', err);
        }
      }

      checkCartForGemstone();

      function setDisabled() {
        addBtn.setAttribute('disabled', '');
        addBtn.classList.add('gemstone-add-btn--disabled');
      }

      function setEnabled() {
        addBtn.removeAttribute('disabled');
        addBtn.classList.remove('gemstone-add-btn--disabled');
      }

      setDisabled();

      function restoreCartedSelection() {
        if (!cartedVariantId) return;
        cards.forEach(card => {
          if (card.dataset.variantId === cartedVariantId) {
            card.setAttribute('aria-selected', 'true');
            if (selectedLabel) {
              selectedLabel.textContent = card.dataset.gemstoneName + ' — ' + card.dataset.gemstonePrice;
            }
            selectedVariantId = cartedVariantId;
            selectedGemstoneName = card.dataset.gemstoneName;
            setEnabled();
            addBtn.textContent = 'Update Gemstone';
          } else {
            card.setAttribute('aria-selected', 'false');
          }
        });
      }

      drawer.addEventListener('dialog:after-show', restoreCartedSelection);

      function showDetail(gemstoneId) {
        if (listView) {
          listView.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
          listView.style.transform = 'translateX(-20px)';
          listView.style.opacity = '0';
          setTimeout(() => {
            listView.style.display = 'none';
            listView.style.transition = '';
            listView.style.transform = '';
            listView.style.opacity = '';
          }, 250);
        }
        detailViews.forEach(view => {
          if (view.dataset.gemstoneDetail === gemstoneId) {
            view.style.opacity = '0';
            view.style.transform = 'translateX(20px)';
            view.style.transition = 'none';
            view.style.display = 'block';
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                view.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
                view.style.transform = 'translateX(0)';
                view.style.opacity = '1';
              });
            });

            // Update footer button for detail mode
            const detailBtn = view.querySelector('.gemstone-detail__select-btn');
            if (detailBtn) {
              addBtn.textContent = 'Select This Gemstone';
              addBtn.removeAttribute('disabled');
              addBtn.classList.remove('gemstone-add-btn--disabled');
              addBtn._detailMode = true;
              addBtn._detailVariantId = detailBtn.dataset.variantId;
              addBtn._detailName = detailBtn.dataset.gemstoneName;
              addBtn._detailPrice = detailBtn.dataset.gemstonePrice;
            }
          } else {
            view.style.display = 'none';
          }
        });
      }

      function showList() {
        detailViews.forEach(view => {
          if (view.style.display !== 'none') {
            view.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
            view.style.transform = 'translateX(20px)';
            view.style.opacity = '0';
            setTimeout(() => {
              view.style.display = 'none';
              view.style.transition = '';
              view.style.transform = '';
              view.style.opacity = '';
            }, 250);
          }
        });
        if (listView) {
          listView.style.opacity = '0';
          listView.style.transform = 'translateX(-20px)';
          listView.style.transition = 'none';
          listView.style.display = 'block';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              listView.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
              listView.style.transform = 'translateX(0)';
              listView.style.opacity = '1';
            });
          });
        }

        // Reset footer button from detail mode
        addBtn._detailMode = false;
        if (!selectedVariantId) {
          setDisabled();
          addBtn.textContent = 'Select This Gemstone';
        } else {
          addBtn.textContent = cartedVariantId ? 'Update Gemstone' : 'Select This Gemstone';
        }
      }

      function resetState() {
        if (listView) {
          listView.style.display = 'block';
          listView.style.transform = '';
          listView.style.opacity = '';
          listView.style.transition = '';
        }
        detailViews.forEach(view => {
          view.style.display = 'none';
          view.style.transform = '';
          view.style.opacity = '';
          view.style.transition = '';
        });

        addBtn._detailMode = false;

        if (!cartedVariantId) {
          cards.forEach(c => c.setAttribute('aria-selected', 'false'));
          setDisabled();
          if (selectedLabel) selectedLabel.textContent = 'No gemstone selected';
          addBtn.textContent = 'Select This Gemstone';
          selectedVariantId = null;
        } else {
          restoreCartedSelection();
        }

        if (!gemstoneAddedToCart && triggerBtn) {
          triggerBtn.textContent = 'Select Your Gemstone';
          triggerBtn.classList.remove('button--outline'); // NEW: back to solid black if nothing's carted
        }
      }

      function selectGemstone(variantId, name, price) {
        selectedVariantId = variantId;
        selectedGemstoneName = name;
        cards.forEach(c => {
          c.setAttribute('aria-selected', c.dataset.variantId === variantId ? 'true' : 'false');
        });
        if (selectedLabel) {
          selectedLabel.textContent = name + ' — ' + price;
        }
        setEnabled();
        addBtn.textContent = cartedVariantId ? 'Update Gemstone' : 'Select This Gemstone';
      }

      cards.forEach(card => {
        card.addEventListener('click', () => {
          selectGemstone(card.dataset.variantId, card.dataset.gemstoneName, card.dataset.gemstonePrice);
        });
        card.addEventListener('keydown', e => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            selectGemstone(card.dataset.variantId, card.dataset.gemstoneName, card.dataset.gemstonePrice);
          }
        });
      });

      viewBtns.forEach(btn => {
        btn.addEventListener('click', e => {
          e.stopPropagation();
          showDetail(btn.dataset.gemstoneId);
        });
      });

      backBtns.forEach(btn => btn.addEventListener('click', showList));

      selectFromDetailBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          selectGemstone(btn.dataset.variantId, btn.dataset.gemstoneName, btn.dataset.gemstonePrice);
          showList();
        });
      });

      drawer.addEventListener('close', resetState);

      // Only remove gemstone linked to this specific ring product
      async function removeGemstonesForProduct(productId) {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          const gemstoneItems = cart.items.filter(item =>
            item.properties &&
            item.properties['_gemstone'] === 'true' &&
            (item.properties['_for_product'] === productId ||
             (!productId && !item.properties['_for_product']))
          );
          if (gemstoneItems.length === 0) return;
          const updates = {};
          gemstoneItems.forEach(item => { updates[item.key] = 0; });
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        } catch (err) {
          console.error('Failed to remove gemstone for product:', err);
        }
      }

      addBtn.addEventListener('click', async () => {

        // Detail mode — select and return to list
        if (addBtn._detailMode) {
          selectGemstone(addBtn._detailVariantId, addBtn._detailName, addBtn._detailPrice);
          addBtn._detailMode = false;
          showList();
          return;
        }

        if (!selectedVariantId) return;

        addBtn.classList.remove('gemstone-add-btn--disabled');
        addBtn.style.pointerEvents = 'none';
        addBtn.innerHTML = 'Adding your gemstone… <span class="gemstone-btn-spinner"></span>';

        try {
          const productId = drawer.dataset.productId || '';

          await removeGemstonesForProduct(productId);

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: parseInt(selectedVariantId),
                quantity: 1,
                properties: {
                  '_gemstone': 'true',
                  '_for_product': productId
                }
              }]
            })
          });

          if (!response.ok) {
            const data = await response.json();
            throw new Error(data.description || 'Cart error');
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );

          cartedVariantId = selectedVariantId;
          gemstoneAddedToCart = true;
          if (triggerBtn) {
            triggerBtn.textContent = selectedLabelText();
            triggerBtn.classList.add('button--outline'); // NEW: transparent once gemstone is added
          }

addBtn.style.pointerEvents = '';

          addBtn.textContent = 'Gemstone Added!';
          setTimeout(() => {
            drawer.hide();
            resetState();
          }, 1000);

        } catch (err) {
          console.error('Gemstone add to cart failed:', err);
          addBtn.style.pointerEvents = '';
          addBtn.textContent = err.message?.toLowerCase().includes('already')
            ? 'Already in cart'
            : 'Error — try again';
          setTimeout(() => {
            drawer.hide();
            resetState();
          }, 2000);
        }
      });

    });
  }

  initGemstoneDrawers();
  document.addEventListener('shopify:section:load', initGemstoneDrawers);


  // ── Remove gemstone when ring is removed from cart ───
  function initCartRingWatcher() {
    document.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('[data-action="remove"]') ||
                        e.target.closest('.line-item__remove') ||
                        e.target.closest('[href*="/cart/change"]');
      if (!removeBtn) return;

      setTimeout(async () => {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          const gemstoneItems = cart.items.filter(item =>
            item.properties && item.properties['_gemstone'] === 'true'
          );
          if (gemstoneItems.length === 0) return;

          const updates = {};
          gemstoneItems.forEach(item => {
            const forProduct = item.properties['_for_product'];
            const linkedRingStillInCart = cart.items.some(
              cartItem => cartItem.product_type === 'Rings' &&
              String(cartItem.product_id) === String(forProduct)
            );
            if (!linkedRingStillInCart) {
              updates[item.key] = 0;
            }
          });

          if (Object.keys(updates).length === 0) return;

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });

          setTimeout(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
          }, 300);

          document.querySelectorAll('x-drawer[id^="gemstone-drawer"]').forEach(drawer => {
            const triggerBtn = document.querySelector(`[aria-controls="${drawer.id}"]`);
            if (triggerBtn) {
              triggerBtn.textContent = 'Select Your Gemstone';
              triggerBtn.classList.remove('button--outline'); // NEW: back to solid black
            }
            drawer._gemstoneInitialised = false;
          });

          initGemstoneDrawers();
        } catch (err) {
          console.error('Failed to watch cart for ring removal:', err);
        }
      }, 1500);
    });
  }

  initCartRingWatcher();

  // ── Remove orphaned gemstones on page load ────────────
  (async function() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const gemstoneItems = cart.items.filter(item =>
        item.properties && item.properties['_gemstone'] === 'true'
      );
      if (gemstoneItems.length === 0) return;
      const updates = {};
      gemstoneItems.forEach(function(item) {
        const forProduct = item.properties['_for_product'];
        const linkedRing = cart.items.some(
          cartItem => cartItem.product_type === 'Rings' &&
          String(cartItem.product_id) === String(forProduct)
        );
        if (!linkedRing) updates[item.key] = 0;
      });
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    } catch (err) {
      console.error('Orphaned gemstone cleanup failed:', err);
    }
  })();


 // ── Sidebar: combined single MutationObserver ────────
function initSidebar() {
  const sidebar = document.getElementById('sidebar-menu');
  if (!sidebar) return;

  const observer = new MutationObserver(() => {
    if (!sidebar.hasAttribute('open')) return;

    const img = sidebar.querySelector('.header-sidebar__promo-card-image');
    if (img) {
      img.style.animation = 'none';
      img.style.opacity = '0';
      setTimeout(() => {
        img.style.animation = 'sidebar-promo-fade-in 0.4s ease forwards';
      }, 400);
    }
  });

  observer.observe(sidebar, { attributes: true, attributeFilter: ['open'] });
}

initSidebar();

  // ── Klaviyo favourites hearts ────────────────────────
  // ── Lazy-mount favourite hearts (perf) ────────────────
// Klaviyo's widget fires one network request PER slot the moment it finds
// it on the page. This detaches off-screen heart slots before Klaviyo's
// script can see them, and reinserts each one ~600px before it scrolls
// into view, so Klaviyo only ever sees a handful at a time instead of 40+.
function initLazyFavouriteSlots() {
  const slots = document.querySelectorAll('.klaviyo-favorites-plp-slot, .klaviyo-wishlist-slot');
  if (!slots.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const placeholder = entry.target;
      const realSlot = placeholder._realSlot;
      if (realSlot && !realSlot.isConnected) {
        placeholder.replaceWith(realSlot);
        initFavouritesHearts(); // safe to call repeatedly — slots guard themselves
      }
      observer.unobserve(placeholder);
    });
  }, { rootMargin: '600px 0px 600px 0px' });

  // Measure every card first, then change the page — measuring between
  // changes forces the browser to re-lay-out the whole page each time.
  const cutoff = window.innerHeight * 1.5;
  const toDefer = Array.from(slots).filter(slot => {
    // Leave hearts above the fold alone — those should render instantly
    const card = slot.closest('.product-card, .product-title-row');
    return !(card && card.getBoundingClientRect().top < cutoff);
  });

  toDefer.forEach(slot => {
    const placeholder = document.createElement('span');
    placeholder.style.cssText = 'display:inline-block;width:1px;height:1px;';
    placeholder._realSlot = slot;
    slot.replaceWith(placeholder);
    observer.observe(placeholder);
  });
}
  function initFavouritesHearts() {
    const containers = document.querySelectorAll(
      '.product-list, .product-card, .featured-collections-carousel, .product-title-row, .favourites-drawer__body'
    );
    if (!containers.length) return;

    containers.forEach(container => {
      container.querySelectorAll('.klaviyo-favorites-plp-slot, .klaviyo-wishlist-slot').forEach(slot => {
        if (slot._favouriteInitialised) return;
        slot._favouriteInitialised = true;

       const productId = slot.dataset.productId;
        if (!productId) return;

        // Needed so the Wishlist drawer/page can resolve a saved ID back to
        // an actual product — Liquid can't look products up by numeric ID.
        const productHandle = (slot.dataset.productUrl || '')
          .split('/products/')[1]?.split(/[?#]/)[0] || null;

        let debounceTimer = null;

        const checkKlaviyoState = () => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            const span     = slot.querySelector('.kl-hub-wishlist-icon');
            const isActive = span && !span.classList.contains('kl-hub-wishlist-icon--inactive');
            const current  = JSON.parse(localStorage.getItem('neij_favourites') || '[]');
            const existingIndex = current.findIndex(item => item && item.id === productId);

            if (isActive && existingIndex === -1) {
              current.push({ id: productId, handle: productHandle });
              localStorage.setItem('neij_favourites', JSON.stringify(current));
              slot.classList.add('is-favourited');
            } else if (!isActive && existingIndex !== -1) {
              current.splice(existingIndex, 1);
              localStorage.setItem('neij_favourites', JSON.stringify(current));
              slot.classList.remove('is-favourited');
            } else if (isActive) {
              slot.classList.add('is-favourited');
            }

            updateHeaderFavouritesIcon();
            // Lets the Wishlist drawer/page (if open) react live — costs
            // nothing on every other page since nothing listens for it there.
            document.dispatchEvent(new CustomEvent('favourites:updated', {
              detail: { id: productId, favourited: isActive }
            }));
          }, 50);
        };

        function attachToButton(button) {
          button.addEventListener('click', () => {
            // Optimistic instant toggle for immediate visual feedback
            const current = JSON.parse(localStorage.getItem('neij_favourites') || '[]');
            const alreadySaved = current.some(item => item && item.id === productId);
            if (alreadySaved) {
              slot.classList.add('is-favourited');
            } else {
              slot.classList.remove('is-favourited');
            }
            updateHeaderFavouritesIcon();
            // Then let Klaviyo confirm the real state shortly after
            setTimeout(checkKlaviyoState, 300);
          });
          const span = slot.querySelector('.kl-hub-wishlist-icon');
          if (span) {
            new MutationObserver(checkKlaviyoState)
              .observe(span, { attributes: true, attributeFilter: ['class'] });
            checkKlaviyoState();
          }
        }

        const existingButton = slot.querySelector('button');
        if (existingButton) {
          attachToButton(existingButton);
        } else {
          // Klaviyo hasn't injected yet — watch for it
          const buttonWatcher = new MutationObserver(() => {
            const btn = slot.querySelector('button');
            if (btn) {
              buttonWatcher.disconnect();
              attachToButton(btn);
            }
          });
          buttonWatcher.observe(slot, { childList: true, subtree: true });
        }
      });
    });
  }

  function updateHeaderFavouritesIcon() {
    const icon = document.getElementById('header-favourites-icon');
    if (!icon) return;
    let favourites = [];
    try {
      favourites = JSON.parse(localStorage.getItem('neij_favourites') || '[]');
    } catch (e) {
      favourites = [];
    }
    // Drop leftover pre-migration entries (bare ID strings, no handle) —
    // the click logic can't match or remove them, so left in place they'd
    // keep this icon permanently "filled" even with nothing favourited.
    const validFavourites = favourites.filter(item => item && typeof item === 'object' && item.handle);
    if (validFavourites.length !== favourites.length) {
      localStorage.setItem('neij_favourites', JSON.stringify(validFavourites));
    }
    icon.classList.toggle('is-filled', validFavourites.length > 0);
  }

  initFavouritesHearts();
  updateHeaderFavouritesIcon();
  initFavouritesDrawer();
  initLazyFavouriteSlots();

  // ── Wishlist drawer ───────────────────────────────────
  function initFavouritesDrawer() {
    const drawer = document.getElementById('favourites-drawer');
    if (!drawer || drawer._favouritesDrawerInitialised) return;
    drawer._favouritesDrawerInitialised = true;

    const body = document.getElementById('favourites-drawer-body');
    const emptyState = document.getElementById('favourites-drawer-empty');
    const footer = document.getElementById('favourites-drawer-footer');

    // ── Session cache — avoids re-fetching items already fetched this
    // session. Clears automatically when the tab closes.
    const CACHE_KEY = 'neij_favourites_drawer_cache';

    function getCache() {
      try {
        return JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
      } catch (e) {
        return {};
      }
    }

    function setCacheEntry(handle, html) {
      try {
        const cache = getCache();
        cache[handle] = html;
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
      } catch (e) {
        // sessionStorage full/unavailable — just skip caching, no harm done
      }
    }

    // Quietly fetches anything not yet cached, only when the browser is
    // truly idle. No-op entirely if nothing is favourited.
    function prefetchItems() {
      let saved = [];
      try {
        saved = JSON.parse(localStorage.getItem('neij_favourites') || '[]');
      } catch (e) {
        return;
      }

      const valid = saved.filter(item => item && typeof item === 'object' && item.handle);
      if (valid.length === 0) return;

      const cache = getCache();
      const missing = valid.filter(item => !cache[item.handle]);
      if (missing.length === 0) return;

      missing.forEach(item => {
        fetch('/products/' + item.handle + '?section_id=favourites-drawer-item')
          .then(res => res.ok ? res.text() : null)
          .then(html => {
            if (html && html.trim()) setCacheEntry(item.handle, html);
          })
          .catch(() => {});
      });
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchItems, { timeout: 4000 });
    } else {
      setTimeout(prefetchItems, 2000);
    }

    async function populateDrawer() {
      body.innerHTML = '';

      let saved = [];
      try {
        saved = JSON.parse(localStorage.getItem('neij_favourites') || '[]');
      } catch (e) {
        saved = [];
      }

      const valid = saved.filter(item => item && typeof item === 'object' && item.handle);

      if (valid.length === 0) {
        emptyState.hidden = false;
        footer.hidden = true;
        return;
      }

      emptyState.hidden = true;
      const cache = getCache();

      const results = await Promise.allSettled(
        valid.map(item => {
          if (cache[item.handle]) {
            return Promise.resolve(cache[item.handle]);
          }
          return fetch('/products/' + item.handle + '?section_id=favourites-drawer-item')
            .then(res => {
              if (!res.ok) throw new Error('Not found: ' + item.handle);
              return res.text();
            })
            .then(html => {
              setCacheEntry(item.handle, html);
              return html;
            });
        })
      );

      let renderedCount = 0;
      results.forEach(result => {
        if (result.status !== 'fulfilled' || !result.value.trim()) return;

        const doc = new DOMParser().parseFromString(result.value, 'text/html');
        const row = doc.querySelector('.favourites-drawer__item');
        if (!row) return;

        const heartSlot = row.querySelector('.klaviyo-favorites-plp-slot');
        if (heartSlot) heartSlot.classList.add('is-favourited');

        body.appendChild(row);
        renderedCount++;
      });

      footer.hidden = renderedCount === 0;
      if (renderedCount === 0) {
        emptyState.hidden = false;
      } else {
        document.dispatchEvent(new Event('shopify:section:load'));
      }
    }

    drawer.addEventListener('dialog:after-show', populateDrawer);

    document.addEventListener('favourites:updated', function(e) {
      const { id, favourited } = e.detail;
      if (favourited) return;

      const row = Array.from(body.children).find(function(el) {
        return el.dataset.productId === id;
      });
      if (!row) return;

      row.remove();

      if (body.children.length === 0) {
        emptyState.hidden = false;
        footer.hidden = true;
      }
    });

    body.addEventListener('click', function(e) {
      const btn = e.target.closest('.favourites-drawer__item-atc');
      if (!btn) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status) {
          btn.disabled = false;
          btn.textContent = 'Try again';
          return;
        }
        btn.textContent = '✓ Added';

        // Close the Wishlist drawer, then open the cart drawer — same
        // hand-off pattern already used by the ring sizer's ATC flow.
        if (typeof drawer.hide === 'function') {
          drawer.hide();
        } else {
          drawer.removeAttribute('open');
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        setTimeout(function() {
          var cartIcon = document.querySelector('[aria-controls="cart-drawer"]');
          if (cartIcon) {
            cartIcon.click();
          }
        }, 500);

        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 2000);
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
    });
  }

  document.addEventListener('shopify:section:load', initFavouritesHearts);
  document.addEventListener('cart:refresh', initFavouritesHearts);
  window.addEventListener('storage', updateHeaderFavouritesIcon);


  // ── Product card image carousel ───────────────────────
  function initProductCardCarousel() {
    document.querySelectorAll('.product-card__figure').forEach(figure => {
      if (figure._carouselInitialised) return;

      // Skip predictive search cards — CSS handles visibility there
      if (figure.closest('.predictive-search__products, predictive-search')) return;

      figure._carouselInitialised = true;

      const card = figure.closest('.product-card');
      if (!card) return;

      const handle = card.getAttribute('handle') ||
                     card.querySelector('a[href*="/products/"]')
                       ?.getAttribute('href')
                       ?.split('/products/')[1]
                       ?.split('?')[0];
      if (!handle) return;

      let imageEls     = Array.from(figure.querySelectorAll('img.product-card__image'));
      let current      = 0;
      let imagesLoaded = false;

      imageEls.forEach((img, i) => {
        img.classList.add(i === 0 ? 'product-card__image--first' : 'product-card__image--stacked');
      });

      function appendImage(src) {
        const img = document.createElement('img');
        img.src = src;
        img.className = 'product-card__image product-card__image--stacked';
        figure.querySelector('.product-card__media').appendChild(img);
        imageEls.push(img);
      }

      function loadRemainingImages() {
        if (imagesLoaded) return;
        imagesLoaded = true;

        const dataImages = card.dataset.images;
        if (dataImages) {
          try {
            JSON.parse(dataImages).slice(imageEls.length).forEach(src => appendImage(src));
          } catch (e) {}
          return;
        }

        fetch(`/products/${handle}.js`)
          .then(r => r.json())
          .then(product => {
            (product.images || []).slice(imageEls.length).forEach(src => appendImage(src));
          })
          .catch(() => {});
      }

      if (canHover) {
        figure.addEventListener('mouseenter', () => {
          loadRemainingImages();
          if (imageEls.length > 1 && current === 0) {
            imageEls[0].classList.remove('product-card__image--visible', 'product-card__image--first');
            imageEls[0].classList.add('product-card__image--stacked');
            imageEls[1].classList.add('product-card__image--visible');
            current = 1;
          }
        });

        figure.addEventListener('mouseleave', () => {
          imageEls[current].classList.remove('product-card__image--visible');
          imageEls[0].classList.remove('product-card__image--stacked');
          imageEls[0].classList.add('product-card__image--first');
          current = 0;
        });
      }

    });
  }

  initProductCardCarousel();
  document.addEventListener('shopify:section:load', initProductCardCarousel);

  // Re-init after Prestige AJAX filter/sort updates
  function reinitAfterFilterUpdate() {
    document.querySelectorAll('.product-card__figure').forEach(f => {
      f._carouselInitialised = false;
    });
    initProductCardCarousel();
    initFavouritesHearts();
    initGemstoneDrawers();
  }

  // Prestige dispatches this custom event after every AJAX collection update
  document.addEventListener('collection:rerendered', reinitAfterFilterUpdate);

  // Fallback observer for AJAX collection updates — the collection:rerendered
  // event above is the primary path, this only catches cases where it doesn't
  // fire. Skipped on product pages: [id*="__main"] matches the main section on
  // EVERY template, so on a PDP this would re-run the carousel, hearts and
  // gemstone init on every Prestige variant re-render. Debounced so a burst of
  // mutations triggers one re-init, not dozens.
  const mainSection = document.querySelector('[id*="__main"].shopify-section');
  const isProductPage = !!document.querySelector('.shopify-section--main-product');
  if (mainSection && !isProductPage) {
    let reinitTimer = null;
    new MutationObserver(() => {
      clearTimeout(reinitTimer);
      reinitTimer = setTimeout(reinitAfterFilterUpdate, 100);
    }).observe(mainSection, { childList: true, subtree: false });
  }

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      document.querySelectorAll('.product-card__figure').forEach(figure => {
        figure._carouselInitialised = false;
      });
      initProductCardCarousel();

      // ── Force reload when returning from checkout ───
      const fromCheckout = document.referrer.includes('/checkouts/') ||
                           document.referrer.includes('checkout.shopify.com');
      if (fromCheckout) {
        window.location.reload();
      }
    }
  });

  // ── Hide Klaviyo hearts in featured collections carousel ──
  function initFeaturedCollectionHeartFix() {
    function hideCarouselHearts() {
      document.querySelectorAll([
        '.featured-collections-carousel .klaviyo-favorites-plp-slot',
        'recently-viewed-products .klaviyo-favorites-plp-slot',
        'product-recommendations .klaviyo-favorites-plp-slot'
      ].join(',')).forEach(slot => {
        slot.style.display = 'none';
      });
    }

    hideCarouselHearts();
    document.addEventListener('shopify:section:load', hideCarouselHearts);

    const dynamicSectionObserver = new MutationObserver(() => {
      initProductCardCarousel();
      hideCarouselHearts();
    });

    document.querySelectorAll('recently-viewed-products, product-recommendations').forEach(el => {
      dynamicSectionObserver.observe(el, { childList: true, subtree: true });
    });
  }

  initFeaturedCollectionHeartFix();

});

// ── Hide floating widgets when any drawer is open ─────────────
(function() {
  const JUDGEME_SELECTOR = '.jdgm-revs-tab-btn';
  const KLAVIYO_SELECTOR = '[data-testid="hub-widget-container"]';

  function applyDrawerStyles(isOpen) {
    const jdgm = document.querySelector(JUDGEME_SELECTOR);
    if (jdgm && window.innerWidth >= 1000) {
      jdgm.style.transition = 'opacity 0.3s ease';
      jdgm.style.opacity = isOpen ? '0' : '1';
      jdgm.style.pointerEvents = isOpen ? 'none' : '';
    }

    const klaviyo = document.querySelector(KLAVIYO_SELECTOR);
    if (klaviyo) {
      klaviyo.style.transition = 'opacity 0.3s ease';
      klaviyo.style.opacity = isOpen ? '0' : '1';
      klaviyo.style.pointerEvents = isOpen ? 'none' : '';
    }
  }

  const observer = new MutationObserver(function() {
    const anyDrawerOpen = document.querySelector('cart-drawer[open], x-drawer[open]') !== null;
    applyDrawerStyles(anyDrawerOpen);
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });
})();

// ── Variant image hover updates selected label ────────
function initVariantImageHover() {
  document.querySelectorAll('.variant-picker__option').forEach(option => {
    if (option._variantImageHoverInitialised) return;
    option._variantImageHoverInitialised = true;

    const label = option.querySelector('.h-stack.gap-1 > span');
    if (!label) return;

    option.querySelectorAll('.thumbnail-swatch').forEach(swatch => {
      const srOnly = swatch.querySelector('.sr-only');
      if (!srOnly) return;

      swatch.addEventListener('mouseenter', () => {
        label.textContent = srOnly.textContent.trim();
      });

      swatch.addEventListener('mouseleave', () => {
        const selected = option.querySelector('.thumbnail-swatch.is-selected .sr-only');
        if (selected) label.textContent = selected.textContent.trim();
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initVariantImageHover);
document.addEventListener('shopify:section:load', initVariantImageHover);
document.addEventListener('variant:changed', initVariantImageHover);

// ── Size Drawer ───────────────────────────────────────────────
function initSizeDrawer() {
  document.querySelectorAll('.size-drawer').forEach(function(drawer) {
    if (drawer._sizeDrawerInitialised) return;
    drawer._sizeDrawerInitialised = true;

    const productId     = drawer.id.split('size-drawer-')[1].split('-')[0];
    const rows          = Array.from(drawer.querySelectorAll('.size-drawer__row'));
    const tabs          = Array.from(drawer.querySelectorAll('.size-drawer__tab'));
    const panels        = Array.from(drawer.querySelectorAll('.size-drawer__panel'));
    const confirmBtn    = drawer.querySelector('.size-drawer__confirm-btn');
    const selectedLabel = drawer.querySelector('.size-drawer__selected-label');
    const hiddenInput   = document.getElementById('size-drawer-property-' + productId);
    const triggerBtn    = document.querySelector('[aria-controls="' + drawer.id + '"]');

    // NEW: Filled (solid) black by default so the customer knows to click it
    // before they can check out. Prestige's .button--outline class is what
    // makes it transparent — removing it falls back to the theme's normal
    // solid button style, same as the ATC button elsewhere. No CSS needed.
    if (triggerBtn) triggerBtn.classList.remove('button--outline');

    let selectedSize      = null;
    let selectedRegion    = null;
    let sizeConfirmed     = false;
    let selectedKaratText = '';

    // ── LIVE lookups — never cache elements Prestige may replace ──────────────
    function getStickyBar() {
      return document.querySelector('product-sticky-bar');
    }

    function getStickyBuyBtns() {
      const sb = getStickyBar();
      return sb ? sb.querySelector('buy-buttons') : null;
    }

    function getAtcButton() {
      const productInfo = drawer.closest('safe-sticky');
      if (productInfo) return productInfo.querySelector('.buy-buttons [type="submit"]');
      return document.querySelector('.buy-buttons [type="submit"]');
    }

    function findKaratOption() {
      return Array.from(document.querySelectorAll('.variant-picker__option')).find(function(opt) {
        const legend = opt.querySelector('legend, .variant-picker__option-name, [class*="option-name"]');
        if (!legend) return false;
        const text = legend.textContent.trim().toLowerCase();
        return text.includes('karat') || text.includes('carat');
      });
    }

    function getKaratRadios() {
      const opt = findKaratOption();
      return opt ? Array.from(opt.querySelectorAll('input[type="radio"]')) : [];
    }

    function getKaratLabelFromRadio(radio) {
      if (!radio) return '';
      const lbl = document.querySelector('label[for="' + radio.id + '"]');
      if (!lbl) return radio.value || '';
      return lbl.querySelector('.sr-only, span')?.textContent.trim() || lbl.textContent.trim();
    }

    // ── Idempotent state enforcers (safe to call repeatedly) ──────────────────
    function hideStickyBuyBtns() {
      // CSS body-class does the real work with zero timing gap.
      // Inline style is belt-and-braces for the initial render.
      document.body.classList.add('neij-size-locked');
      const el = getStickyBuyBtns();
      if (el && el.style.display !== 'none') el.style.display = 'none';
    }

    function showStickyBuyBtns() {
      document.body.classList.remove('neij-size-locked');
      const el = getStickyBuyBtns();
      if (el) {
        el.style.display = '';
        el.classList.add('sticky-atc--reveal');
      }
    }

    function ensureStickyInner() {
      if (!stickyInner) return;
      const btns = getStickyBuyBtns();
      if (!btns) return;
      // Re-attach into the LIVE sticky bar if Prestige replaced it
      if (btns.previousElementSibling !== stickyInner) {
        stickyInner.style.opacity = '';
        btns.before(stickyInner);
      }
    }

    function lockInlineAtc() {
      const el = getAtcButton();
      if (!el || el.getAttribute('data-size-disabled')) return;
      el.setAttribute('data-size-disabled', 'true');
      el.setAttribute('data-original-text', el.textContent.trim());
      el.disabled = true;
      el.textContent = 'Select your size to checkout';
      el.style.opacity = '0.35';
      el.style.cursor = 'not-allowed';
    }

    // Injects OR updates the summary — must refresh text when karat changes
    function injectStickySummary() {
      if (window.innerWidth < 1000 || !selectedSize) return;
      const sb = getStickyBar();
      if (!sb) return;
      const innerVStack = sb.querySelector('.product-sticky-bar__info .h-stack .v-stack');
      if (!innerVStack) return;

      const parts = [selectedKaratText, 'Size: ' + selectedSize + ' (' + selectedRegion + ')'].filter(Boolean);
      const text  = parts.join(' · ');

      const existing = innerVStack.querySelector('.sticky-variant-summary');
      if (existing) {
        // Update in place — only write if changed, to avoid observer loops
        if (existing.textContent !== text) existing.textContent = text;
        return;
      }

      const summary = document.createElement('p');
      summary.className = 'sticky-variant-summary';
      summary.textContent = text;

      const priceList = innerVStack.querySelector('price-list, .price-list');
      if (priceList) innerVStack.insertBefore(summary, priceList);
      else innerVStack.appendChild(summary);
    }

    function syncKaratButtons() {
      if (!stickyInner) return;
      const radios = getKaratRadios();
      stickyInner.querySelectorAll('.sticky-karat-btn').forEach(function(btn) {
        const val = btn.getAttribute('data-karat-value');
        const match = radios.find(function(r) { return r.value === val; });
        btn.classList.toggle('is-selected', !!(match && match.checked));
      });
    }

    // ── Build sticky proxy: karat buttons + Select Your Size ──────────────────
    let stickyInner    = null;
    let karatInputName = null;

    if (getStickyBar() && getStickyBuyBtns()) {

      const karatRadios = getKaratRadios();
      if (karatRadios.length) karatInputName = karatRadios[0].name;

      const initialChecked = karatRadios.find(function(r) { return r.checked; });
      if (initialChecked) selectedKaratText = getKaratLabelFromRadio(initialChecked);

      const stickyKaratWrap = document.createElement('div');
      stickyKaratWrap.className = 'sticky-karat-btns';

      karatRadios.forEach(function(radio) {
        const labelText = getKaratLabelFromRadio(radio);
        const value     = radio.value;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sticky-karat-btn' + (radio.checked ? ' is-selected' : '');
        btn.textContent = labelText;
        btn.setAttribute('data-karat-value', value);

        btn.addEventListener('click', function() {
          // Re-query LIVE radios — the originals are stale after any re-render
          const live = getKaratRadios().find(function(r) { return r.value === value; });
          if (!live) return;
          live.checked = true;
          // Dispatch so Prestige updates variant ID / price / cart form
          live.dispatchEvent(new Event('change', { bubbles: true }));
          selectedKaratText = labelText;
          syncKaratButtons();
        });

        stickyKaratWrap.appendChild(btn);
      });

      const stickySizeBtn = document.createElement('button');
      stickySizeBtn.type = 'button';
      stickySizeBtn.className = 'button button--solid button--full-width';
      stickySizeBtn.setAttribute('data-sticky-size-btn', 'true');
      stickySizeBtn.textContent = 'Select Your Size';
      stickySizeBtn.addEventListener('click', function() {
        drawer.show();
      });

      stickyInner = document.createElement('div');
      stickyInner.className = 'sticky-size-inner';
      if (karatRadios.length) stickyInner.appendChild(stickyKaratWrap);
      stickyInner.appendChild(stickySizeBtn);

      getStickyBuyBtns().before(stickyInner);
      hideStickyBuyBtns();
    }

    // Keep karat state + summary in sync when changed on the main PDP
    document.addEventListener('change', function(e) {
      if (!karatInputName) return;
      if (!e.target.matches('input[type="radio"]')) return;
      if (e.target.name !== karatInputName) return;
      selectedKaratText = getKaratLabelFromRadio(e.target);
      syncKaratButtons();
      if (sizeConfirmed) injectStickySummary();
    });

    lockInlineAtc();

    // ── Re-render observer — operates on LIVE elements only ───────────────────
    function onRerender() {
      if (sizeConfirmed) {
        injectStickySummary();
        return;
      }
      hideStickyBuyBtns();
      ensureStickyInner();
      syncKaratButtons();
      lockInlineAtc();
    }

    const buyButtonsBlock = document.querySelector('[data-block-type="buy-buttons"]');
    if (buyButtonsBlock) {
      new MutationObserver(onRerender).observe(buyButtonsBlock, { childList: true, subtree: true });
    }

    // product-rerender is the ANCESTOR of product-sticky-bar, not a descendant.
    // Observe the wrapper (which survives) so we catch the sticky bar being
    // wholesale replaced. Falls back to the parent element if absent.
    const initialSticky = getStickyBar();
    const stickyWrapper = initialSticky
      ? (initialSticky.closest('product-rerender') || initialSticky.parentElement)
      : null;
    if (stickyWrapper) {
      new MutationObserver(onRerender).observe(stickyWrapper, { childList: true, subtree: true });
    }

    // ── Tab switching ─────────────────────────────────────────────────────────
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function(p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const targetPanel = drawer.querySelector('#size-panel-' + tab.dataset.tab + '-' + productId);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
          targetPanel.setAttribute('aria-hidden', 'false');
        }
      });
    });

    // ── Row selection ─────────────────────────────────────────────────────────
    rows.forEach(function(row) {
      row.addEventListener('click', function() {
        selectSize(row.dataset.size, row.dataset.region);
      });
      row.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          selectSize(row.dataset.size, row.dataset.region);
        }
      });
    });

    function selectSize(size, region) {
      selectedSize   = size;
      selectedRegion = region;
      rows.forEach(function(r) {
        r.setAttribute('aria-selected', r.dataset.size === size && r.dataset.region === region ? 'true' : 'false');
      });
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Confirm — ' + size + ' (' + region + ')';
      selectedLabel.textContent = size + ' (' + region + ') selected';
      selectedLabel.classList.add('has-selection');
    }

    // ── Confirm ───────────────────────────────────────────────────────────────
    confirmBtn.addEventListener('click', function() {
      if (!selectedSize) return;

      sizeConfirmed = true;

      if (hiddenInput) hiddenInput.value = selectedSize + ' (' + selectedRegion + ')';
      if (triggerBtn) {
        triggerBtn.textContent = 'Size: ' + selectedSize + ' (' + selectedRegion + ')';
        // NEW: back to transparent/outline now that a size is locked in
        triggerBtn.classList.add('button--outline');
      }

      // Re-enable inline ATC
      const atc = getAtcButton();
      if (atc && atc.getAttribute('data-size-disabled') === 'true') {
        atc.removeAttribute('data-size-disabled');
        atc.textContent = atc.getAttribute('data-original-text') || 'Add to Bag';
        atc.removeAttribute('data-original-text');
        atc.disabled = false;
        atc.style.opacity = '';
        atc.style.cursor = '';
      }

      // Swap sticky: fade out proxy, reveal real ATC + inject summary
      if (stickyInner) {
        stickyInner.style.transition = 'opacity 0.2s ease';
        stickyInner.style.opacity = '0';
        setTimeout(function() {
          stickyInner.remove();
          stickyInner = null;
          showStickyBuyBtns();
          injectStickySummary();
        }, 200);
      } else {
        showStickyBuyBtns();
        injectStickySummary();
      }

      drawer.hide();
    });

    // ── Reset on close ────────────────────────────────────────────────────────
    drawer.addEventListener('close', function() {
      tabs.forEach(function(t) {
        const isAU = t.dataset.tab === 'au';
        t.classList.toggle('is-active', isAU);
        t.setAttribute('aria-selected', isAU ? 'true' : 'false');
      });
      panels.forEach(function(p) {
        const isAU = p.dataset.panel === 'au';
        p.classList.toggle('is-active', isAU);
        p.setAttribute('aria-hidden', isAU ? 'false' : 'true');
      });
    });
  });
}

initSizeDrawer();
document.addEventListener('shopify:section:load', initSizeDrawer);

// Trigger blur overlay immediately on mega menu hover — scoped to header nav only
document.querySelectorAll('x-header details.header__menu-disclosure').forEach(details => {
  details.addEventListener('mouseenter', () => {
    document.body.classList.add('mega-menu-open');
  });
  details.addEventListener('mouseleave', () => {
    document.body.classList.remove('mega-menu-open');
  });
});